import React from "react";
import { parsal_img } from "../../../assets/mediaCall";

const Hero = () => {
  return (
    <div className="inter relative flex smm:flex-col-reverse items-center justify-center gap-10 mdg:gap-4 smm:gap-6 w-[85vw] mlg:w-[90vw] smp:w-[96vw] mx-auto pb-28 xxl:pb-36 mlg:pb-10">
      {/* Left - Text Section */}
      <div className="w-[40%] lg:w-[50%] smm:w-[100%] sm:w-[90%] smm:mx-auto">
        <h1 className="mdg:hidden text-4xl font-black sm:text-2xl text-[var(--clr-black-1)] mb-4">
          Effortless Logistics <br /> at Your Fingertips
        </h1>
        <h1 className="hidden mdg:block text-4xl mdg:text-[34px] font-black sm:text-[26px] sm:leading-[32px] text-[var(--clr-black-1)] mb-4">
          Effortless Logistics at Your Fingertips
        </h1>
        <p className="text-lg mdg:text-base text-[var(--clr-grey-1)] mb-8">
          Streamline your shipping and tracking with PARSAL Logistic.
        </p>
        {/* App Store & Google Play Buttons */}
        <div className="flex space-x-4">
          <div>
            <img
              src={parsal_img.appstore} // Replace with the correct path
              alt="Download on the App Store"
              className="w-44 h-auto"
            />
          </div>
          <div>
            <img
              src={parsal_img.playstore} // Replace with the correct path
              alt="Get it on Google Play"
              className="w-44 h-auto"
            />
          </div>
        </div>
      </div>

      {/* Right - Image Section */}
      <div className="w-[40%] lg:w-[50%] flex justify-center smm:w-[70%] smm:mx-auto smm:mt-2 sm:mt-0">
        <img
          src={parsal_img.parsal} // Replace with the actual path to your illustration
          alt="Logistics illustration"
          className="object-contain w-full h-auto max-h-[500px] smm:hidden" // Adjust max height to fit the screen
        />
        <img
          src={parsal_img.parsal3} // Replace with the actual path to your illustration
          alt="Logistics illustration"
          className="object-contain w-full h-auto max-h-[500px] hidden smm:block" // Adjust max height to fit the screen
        />
      </div>
    </div>
  );
};
export default Hero;
